import React, { useState } from 'react';
import axios from 'axios';
// import './ResidentCalculator.css';
import { NGROK_URL } from '../../utils/const';

const formSchema = {
  workingHoliday: {
    fields: [
      {
        type: 'radio',
        name: 'workingHoliday',
        label: 'Are you on a working holiday? *',
        required: true,
        options: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
        ]
      }
    ]
  },

  migratingAU: {
    // title: 'Occupancy Expenses',
    condition: (formData) => formData.workingHoliday === 'no',
    fields: [
      {
        type: 'radio',
        name: 'migratingAU',
        label: 'Are you migrating and settling in Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]
  },
  returningToAU: {
    condition: (formData) => formData.migratingAU === 'no',
    fields: [
      {
        type: 'radio',
        name: 'returningToAU',
        label: 'Are you an Australian returning to live in Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]
  },
  sixMonthStayInAU: {
    condition: (formData) => formData.returningToAU === 'no',
    fields: [
      {
        type: 'radio',
        name: 'sixMonthStayInAU',
        label: 'Have you stayed or do you intend to stay in Australia for six months or more? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]
  },
  hasSocioEconomicTies: {
    condition: (formData) => formData.sixMonthStayInAU === 'no',
    fields: [
      {
        type: 'radio',
        name: 'hasSocioEconomicTies',
        label: 'Do you have social or economic ties to a country other than Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]
  },
  residencePurpose: {
    // title: 'Basic Information',
    condition:(formData) => formData.sixMonthStayInAU === 'yes',
    fields: [
      {
        type: 'select',
        name: 'residencePurpose',
        label: 'What is your main purpose for being in Australia? *',
        required: true,
        options: [
            { value: '', label: 'Select main purpose' },
            { value: 'employment', label: 'Employment contract or permanent employment' },
            { value: 'exchangeResearch', label: 'Exchange program or full time research' },
            { value: 'education', label: 'Full time education' },
            { value: 'holidayingCasual', label: 'Holidaying or casual employment' },
            { value: 'friendsRelatives', label: 'Visiting friends or relatives' },
            { value: 'other', label: 'Other reasons' },
        ]
      }
    ]
  },
  sixMonthStay:{
    condition: (formData) => formData.residencePurpose !== 'other' && formData.residencePurpose !== '',
    fields: [
      {
        type: 'radio',
        name: 'sixMonthStay',
        label: 'Have you stayed or do you intend to stay in a particular place continuously for six months or more? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]
  },
locationInAU:{
    condition:(formData) => formData.residencePurpose !== 'other' && formData.residencePurpose !== '',
    fields: [
      {
        type: 'select',
        name: 'locationInAU',
        label: 'Where do you live in Australia? *',
        required: true,
        options: [
            { value: '', label: 'Select Location' },
            { value: 'familyFriends', label: 'Staying with family, friends' },
            { value: 'ownBuyHome', label: 'Own or buying a home' },
            { value: 'rentLease', label: 'Renting or leasing accommodation' },
            { value: 'hotel', label: 'Hotel, motel, hostel or caravan' },
            { value: 'university', label: 'University campus' }
        ]
      }
    ]
  },
  hasSpouseOrDependantChildren:{
    condition:(formData) => formData.residencePurpose !== 'other'&& formData.residencePurpose !== '',
    fields: [
      {
        type: 'radio',
        name: 'hasSpouseOrDependantChildren',
        label: 'Do you have a spouse and/or dependent children? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]  
},
spouseOrDependantChildrenLocation:{
  condition:(formData) => formData.hasSpouseOrDependantChildren === 'yes',
  fields: [
    {
      type: 'select',
      name: 'spouseOrDependantChildrenLocation',
      label: 'Where do you live with your spouse and/or dependent children? *',
      required: true,
      options: [
        { value: '', label: 'Select Location' },
        { value: 'currentlyLiving', label: 'Currently living with you' },
        { value: 'comingToLive', label: 'Coming to live with you' },
        { value: 'overseas', label: 'Remaining overseas' },
        { value: 'someHere', label: 'Some with you and some overseas' }
      ]
    }
  ]},
  assetsHoldingLocation:{
    condition:(formData) => formData.hasSpouseOrDependantChildren === 'yes',
    fields: [
      {
        type: 'radio',
        name: 'assetsHoldingLocation',
        label: 'Where do you hold the majority of your assets? *',
        required: true,
        options: [
          { value: 'Australia', label: 'Australia' },
          { value: 'Overseas', label: 'Overseas' }
        ]
      }
    ]  
  },
  clubMember:{
    condition:(formData) => formData.hasSpouseOrDependantChildren === 'yes',
    fields: [
      {
        type: 'radio',
        name: 'clubMember',
        label: 'Are you a member of any clubs, churches, community groups or organisations in Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]  
  },
  is183DaysResident:{
    condition:(formData) => (formData.spouseOrDependantChildrenLocation === 'remaining_overseas' && formData.assetsHoldingLocation === 'overseas') || (formData.spouseOrDependantChildrenLocation === 'some_with_you_and_some_overseas' && formData.assetsHoldingLocation === 'overseas'&& formData.clubMember === 'no'),
    fields: [
      {
        type: 'radio',
        name: 'is183DayResident',
        label: 'Have you been in Australia, either continuously or intermittently, for 183 days or more in the income year? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]  
  },
isResidenceOutOfAU:{
        condition:(formData) => (formData.spouseOrDependantChildrenLocation === 'remaining_overseas' && formData.assetsHoldingLocation === 'overseas' && formData.is183DayResident==='yes'),
    fields: [
      {
        type: 'radio',
        name: 'isResidenceOutOfAU',
        label: 'Is your usual place of abode outside of Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]  
    },
takeResidenceInAU:{
        condition:(formData) => formData.isResidenceOutOfAU === 'yes',
    fields: [
      {
        type: 'radio',
        name: 'takeResidenceInAU',
        label: 'Do you intend to take up residence in Australia? *',
        required: true,
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' }
        ]
      }
    ]  
    },
};

const ResidentTaxCalculator = () => {
  const [formData, setFormData] = useState({
    workingHoliday:'',
    migratingAU: '',
    returningToAU:'',
    sixMonthStayInAU:'',
    hasSocioEconomicTies:'',
    residencePurpose:'',
    sixMonthStay:'',
    locationInAU:'',
    hasSpouseOrDependantChildren:'',
    spouseOrDependantChildrenLocation:'',
    assetsHoldingLocation:'',
    clubMember:'',
    is183DayResident:'',
    isResidenceOutOfAU:'',
    takeResidenceInAU:'',
    
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? parseFloat(value) || 0 : value
    }));
  };

  const renderField = (field) => {
    if (field.condition && !field.condition(formData)) return null;

    switch (field.type) {
      case 'select':
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <select
              id={field.name}
              name={field.name}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            >
              {field.options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        );

      case 'radio':
        return (
          <div key={field.name} className="form-group">
            <label>{field.label}</label>
            <div className="radio-group">
              {field.options.map(opt => (
                <div key={opt.value} className="radio-option">
                  <input
                    type="radio"
                    id={`${field.name}-${opt.value}`}
                    name={field.name}
                    value={opt.value}
                    checked={formData[field.name] === opt.value}
                    onChange={handleChange}
                    required={field.required}
                  />
                  <label htmlFor={`${field.name}-${opt.value}`}>
                    {opt.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        );

      case 'currency':
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <div className="input-with-prefix">
              <span className="currency-symbol">{field.prefix}</span>
              <input
                type="number"
                id={field.name}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                step="0.01"
              />
            </div>
          </div>
        );

      case 'number':
        return (
          <div key={field.name} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <div className="input-with-suffix">
              <input
                type="number"
                id={field.name}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
              />
              {field.suffix && <span className="unit">{field.suffix}</span>}
            </div>
          </div>
        );

      // Add other field types as needed
    }
  };

  const renderSection = (section, sectionKey) => {
    if (section.condition && !section.condition(formData)) return null;

    return (
      <div key={sectionKey} className="form-section">
        <h2>{section.title}</h2>
        {section.fields.map(field => renderField(field))}
      </div>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const payload = {
        aus_citizen: true,
        target_working_holiday: formData.workingHoliday||null,
        target_migrating: formData.migratingAU||null,
        target_returning: formData.returningToAU||null,
        target_length_of_stay: formData.sixMonthStayInAU||null,
        target_soc_eco_ties: formData.hasSocioEconomicTies||null,
        target_main_purpose: formData.residencePurpose||null,
        target_cont_stay: formData.sixMonthStay||null,
        target_live_location: formData.locationInAU||null,
        target_spouse: formData.hasSpouseOrDependantChildren||null,
        target_spouse_location: formData.spouseOrDependantChildrenLocation||null,
        target_assets: formData.assetsHoldingLocation||null,
        target_member: formData.clubMember||null
      };

    //   // Remove empty or null values
    //   Object.keys(payload).forEach(key => {
    //     if (!payload[key]) {
    //       delete payload[key];
    //     }
    //   });

      const response = await axios.post(NGROK_URL + '/ato_calculator/calculate-residency', payload);
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred while processing your request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <h1>Are you a resident?</h1>
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        {Object.entries(formSchema).map(([key, section]) => 
          renderSection(section, key)
        )}
        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? 'Calculating...' : 'Calculate'}
        </button>
      </form>

      {loading && (
        <div className="loader">
          {/* <div className="spinner"></div> */}
          {/* <p>Calculating your tax residency status...</p> */}
        </div>
      )}

      {result && (
        <div className="result-container">
          <h2>Results</h2>
          <div className="result-content">
            <p><strong>Residency Status:</strong> {result.residency_status}</p>
            {result.explanation && (
              <p><strong>Explanation:</strong> {result.explanation}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResidentTaxCalculator;